import EventEmitter from './EventEmitter';
export default class Mouse extends EventEmitter {
    constructor() {
        super();
        // Setup
        this.x = 0;
        this.y = 0;
        this.inComputer = false;
        this.isDown = false;
        this.lastX = 0;
        this.lastY = 0;
        // this.application = new Application();
        // this.audio = this.application.world.audio;
        window.addEventListener('mousemove', (event) => {
            if (event.clientX && event.clientY) {
                this.x = event.clientX;
                this.y = event.clientY;
            }
            // @ts-ignore
            this.inComputer = event.inComputer ? true : false;
        });
        window.addEventListener('mousedown', () => {
            this.isDown = true;
            this.lastX = this.x;
            this.lastY = this.y;
        });
        window.addEventListener('mouseup', () => {
            this.isDown = false;
        });
    }
}
